import * as actions from './actions';
import messages from './messages';
import * as studentRollActions from '../student-roll/actions';
import * as editStudentActions from '../edit-student/actions';
import * as classRollActions from '../class-roll/actions';
import { filterProductCountries } from '../../helpers/utils';

const tabs = {
    data: [
        { id: 1, name: 'Students', route: 'students' },
        { id: 2, name: 'Teachers', route: 'teachers' },
        { id: 3, name: 'Classes', route: 'classes' }
    ]
};

const initState = {
    licenceSummaryTitle: messages.licenceSummary.defaultMessage,
    licenceSummary: undefined,
    tabs,
    loadLicenceSummary: true,
    loadClassroomData: true,
    yearGroups: [],
    isYearGroupDataLoaded: false,
    countries: {
        raw: [],
        filtered: []
    },
    upfCountries: {
        raw: [],
        filtered: []
    },
    isCountriesLoaded: false,
    isUpfCountriesLoaded: false,
    lastAddedTeacherUserProfileId: 0
};

export default function (state = initState, action) {
    switch (action.type) {
    case classRollActions.DELETE_CLASSROOMS_SUCCESS:
    case editStudentActions.UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS:
    case studentRollActions.UNASSIGN_STUDENTS_SUCCESS:
    case studentRollActions.ADD_STUDENT_SUCCESS:
    case actions.GET_LICENCE_CAP_SUMMARY_REQUEST: {
        return { ...state, loadLicenceSummary: true };
    }

    case actions.GET_LICENCE_CAP_SUMMARY_SUCCESS: {
        const licenceDetail = action.data;

        let licenceSummary = licenceDetail.remainingLicenceCount.toString();
        let licenceSummaryTitle = messages.licenceSummary.defaultMessage;
        if (!licenceDetail.isActive) {
            licenceSummary = messages.expiredLicence.defaultMessage;
            licenceSummaryTitle = '';
        }
        return { ...state, licenceSummary, licenceSummaryTitle, loadLicenceSummary: false };
    }
    case actions.GET_LICENCE_CAP_SUMMARY_FAILURE: {
        return { ...state, loadLicenceSummary: false };
    }

    case actions.GET_COUNTRIES_REQUEST: {
        return { ...state, isCountriesLoaded: false };
    }
    case actions.GET_COUNTRIES_SUCCESS: {
        return {
            ...state,
            isCountriesLoaded: true,
            countries: { raw: action.data, filtered: filterProductCountries(action.data) }
        };
    }
    case actions.GET_COUNTRIES_FAILURE: {
        return { ...state, isCountriesLoaded: true };
    }

    case actions.GET_UPF_COUNTRIES_REQUEST: {
        return { ...state, isUpfCountriesLoaded: false };
    }
    case actions.GET_UPF_COUNTRIES_SUCCESS: {
        return {
            ...state,
            isUpfCountriesLoaded: true,
            upfCountries: { raw: action.data, filtered: filterProductCountries(action.data) }
        };
    }
    case actions.GET_UPF_COUNTRIES_FAILURE: {
        return { ...state, isUpfCountriesLoaded: true };
    }

    case actions.GET_YEAR_GROUPS_REQUEST:
    {
        return { ...state, isYearGroupDataLoaded: false };
    }

    case actions.GET_YEAR_GROUPS_SUCCESS: {
        return { ...state, isYearGroupDataLoaded: true, yearGroups: action.data };
    }

    case actions.GET_YEAR_GROUPS_FAILURE: {
        return { ...state, isYearGroupDataLoaded: true };
    }
    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/school-roll/reducer.js